<li in:fly={{ delayMultiplier: index }}>
  <a
    href={href}
    class:mh-tier-2={tier === 2}
    class={tier === 2 ? colorClassNames.secondary : colorClassNames.primary}
    {...normalisedDataAttributes}
  >
    {text}
  </a>
</li>

<style lang="less">
  @import (reference) '../../../less/variables';

  li {
    display: inline-block;

    &:last-child > a {
      padding-right: 0;
    }

    /*
     * The additional styles below
     * override encore-web global
     * styles
     */
    font-size: @masthead-font-size-medium;
    line-height: inherit;
    letter-spacing: 0;
  }

  a {
    display: block;
    padding: 28px 17px;

    text-decoration: none;
    font-weight: @masthead-font-weight-bold;

    &:hover,
    &:focus {
      color: currentColor;
    }
  }

  @media (max-width: @breakpoint-tablet - 1) {
    li {
      display: block;
      margin: 0;
    }

    a {
      display: block;
      cursor: pointer;
      line-height: 1;
      padding: 0 0 25px 0;
      font-weight: @masthead-font-weight-bold;
      font-size: @masthead-font-size-tablet-large;

      &.mh-tier-2 {
        font-weight: @masthead-font-weight-normal;
        font-size: @masthead-font-size-tablet-medium;
      }
    }
  }

  @media (max-width: @breakpoint-mobile-narrow - 1) {
    a {
      font-size: @masthead-font-size-mobile-large;

      &.mh-tier-2 {
        font-size: @masthead-font-size-mobile-medium;
      }
    }
  }
</style>

<script>
  import { fly } from '../../../lib/animation';
  import { normaliseDataAttributes } from '../../../lib/normaliseDataAttributes';

  export let index = 0;
  export let href;
  export let text;
  export let dataAttributes = {};
  export let tier = 1;
  export let colorClassNames;

  $: normalisedDataAttributes = normaliseDataAttributes(dataAttributes);
</script>
